import type { ListMatrixModelsParams } from '../api/matrix-models.api';
import ModelsFilterModal from '../ui/ModelsFilterModal.vue';
import {
  buildModelsListUrlQuery,
  countActiveModelFilters,
  parseModelsListFilters,
  parseModelsListSort,
  toModelsListSort,
} from '../lib/models-list-query';
import type { ModelsListFilters, ModelsListSort } from '../lib/models-list-query';
import { useListControls } from './useListControls';
import type { ListControlsOptions } from './useListControls';

type ModelListRequestParams = Pick<
  ListMatrixModelsParams,
  'sort' | 'order' | 'createdAt' | 'categoryIds' | 'createdBy'
>;

export function useModelListControls(options: ListControlsOptions) {
  return useListControls<ModelsListSort, ModelsListFilters, ModelListRequestParams>(
    {
      filterModal: ModelsFilterModal,
      parseSort: parseModelsListSort,
      parseFilters: parseModelsListFilters,
      toSort: toModelsListSort,
      pickFilters: ({ createdAt, categoryId, createdBy }) => ({ createdAt, categoryId, createdBy }),
      countFilters: countActiveModelFilters,
      buildUrlQuery: buildModelsListUrlQuery,
      toRequestParams: (sortState, filters) => ({
        sort: sortState.sort || undefined,
        order: sortState.order || undefined,
        createdAt: filters.createdAt,
        categoryIds: filters.categoryId ? [filters.categoryId] : undefined,
        createdBy: filters.createdBy,
      }),
    },
    options
  );
}
